import React from "react";
import "./Transaction_History.css";
import Common_white_header from "../Common/Common_Component/Common_white_header/Common_white_header";
import Filter_Drop from "../Common/Common_Component/Filter_Drop/Filter_Drop";
import Transaction_History_card from "./Transaction_History_card/Transaction_History_card";
import No_data from "../Common/No_data/No_data";

function Transaction_History() {

  const transactionData = [
    {
      detail: "Game Moved Out",
      time: "2026-03-11 11:19:00",
      balance: "2.99",
      type: "out",
    },
    {
      detail: "Game Moved In",
      time: "2026-03-11 10:00:00",
      balance: "5.50",
      type: "in",
    },
    {
      detail: "Game Moved Out",
      time: "2026-03-10 09:30:00",
      balance: "1.20",
      type: "out",
    },
    {
      detail: "Game Moved In",
      time: "2026-03-09 07:10:00",
      balance: "10.00",
      type: "in",
    },
  ];

  return (
    <>
      <section className="Transaction_History">
        <Common_white_header headingText={"Transaction History"} />

        <div className="container">

          <Filter_Drop />

          {transactionData.map((item, index) => (
            <Transaction_History_card
              key={index}
              detail={item.detail}
              time={item.time}
              balance={item.balance}
              type={item.type}
            />
          ))}

           <No_data/>

        </div>
      </section>
    </>
  );
}

export default Transaction_History;